<template>
    <div class="share-container">
        <div class="refer-link-container mb3 fl w-100">
            <div class="email-input-group">
                <label for="referLink" class="f4 fw7 db mb3 tc-ns tl pb1">Share your link for credit:</label>
                <input v-model="referLink" id="refer-link" name="refer-link" type="text" placeholder="Referral Link..." class="mono fw4 f55 black-80 input-reset bg-black-10 pv35 w-two-thirds-ns w-100 ph3 bn fl ma0 lh-copy" disabled>
                <button v-clipboard:copy="referLink"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onCopyError"
                    class="sans-serif fw7 f55 button-reset pv35 ph3 white pointer fl w-third-ns w-100 bn bg-black-90 tc lh-copy">
                    Copy Link
                </button>
            </div>
        </div>
        <div class="social-container mb3 fl w-100">
            <div class="flex email-input-group">
                <div class="social-link-container w-third mr3-ns mr2 dib">
                    <a v-bind:href="facebookLink" target="_blank"><button class="fw7 f55 sans-serif link button-reset pv35 ph3 tc bg-white black-80 pointer dib w-100 ambassador-btn ba bw1 b--black-80">Facebook</button></a>
                </div>
                <div class="social-link-container w-third mr3-ns mr2 dib">
                    <a v-bind:href="twitterLink" target="_blank"><button class="fw7 f55 sans-serif link button-reset pv35 ph3 tc bg-white black-80 pointer dib w-100 ambassador-btn ba bw1 b--black-80">Twitter</button></a>
                </div>
                <div class="social-link-container w-third dib">
                    <a v-bind:href="linkedinLink" target="_blank"><button class="fw7 f55 sans-serif link button-reset pv35 ph3 tc bg-white black-80 pointer dib w-100 ambassador-btn ba bw1 b--black-80">Linkedin</button></a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import request from 'request';

export default {
    props: {
        user: Object
    },
    data() {
        return {
            userDict: {},
            referLink: process.env.BASE_URL + "?ref=",
            facebookLink: "https://www.facebook.com/sharer/sharer.php?u=",
            twitterLink: "https://twitter.com/home?status=",
            linkedinLink: "https://www.linkedin.com/shareArticle?mini=true&url=",
            userObj: {
                email: this.user.email,
                uid: this.user.uid
            }
        }
    },
    methods: {
        fetchData() {
            var self = this;
            var options = {
                url: process.env.HOME_API + "/api/users/" + this.userObj.uid,
                method: 'GET',
            }

            request(options, function (error, response, body) {
                var json = JSON.parse(body);
                self.userDict = json.user[0];
                self.referLink = self.referLink + self.userDict.refer_id;
                self.facebookLink = self.facebookLink + self.referLink,
                self.twitterLink = self.twitterLink + self.referLink,
                self.linkedinLink = self.linkedinLink + self.referLink + "&title=&summary=&source="
            });
        },
        onCopy: function (e) {

        },
        onCopyError: function (e) {

        }
    },
    mounted() {
        if (this.user.email !== "" && this.user.uid !== "") {
            this.fetchData();
        }
    },
    watch: {
        user: {
            handler(newUser, oldUser) {
                this.userObj = newUser;
                this.fetchData();
            },
            deep: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// _vue/components/Share.vue